import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
    })
  };

@Injectable({
  providedIn: 'root'
})


export class HttpService {

  constructor(private http: HttpClient) {
  }

  postContactForm(data: JSON) {
    this.http.post('./save_user_data.php', data, httpOptions)
      .subscribe(
        data => console.log(data)
      );
  }

  send_email(data: JSON) {
    this.http.post('./send_email.php', data, httpOptions)
      .subscribe(
        data => console.log(data)
      );
  }
}
